import React from 'react';
import CloseIcon from 'svg/CloseIcon';
import { Button, ButtonText } from 'components/Button';
import Modal from 'components/modals/Modal';

interface ModalVairInfoProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm?: () => void;
  title: string;
  message: string;
}

export default function ModalVairInfo({
  isOpen,
  onClose,
  onConfirm,
  title,
  message,
}: ModalVairInfoProps) {
  return (
    <Modal isOpen={isOpen} handleClose={onClose}>
      <div className="flex flex-col justify-between gap-8 px-6 pb-5 pt-6">
        <div className="flex flex-row justify-between text-left">
          <h3 className="typography-product-heading-compact text-left text-color-text-lightmode-primary dark:text-color-text-darkmode-primary">
            {title}
          </h3>
          <ButtonText onClick={onClose}>
            <CloseIcon />
          </ButtonText>
        </div>
        <p className="typography-product-body font-normal text-color-text-lightmode-secondary dark:text-color-text-darkmode-secondary">
          {message}
        </p>
        {onConfirm ? (
          <div className="flex w-full flex-col gap-3">
            <Button variant="primary" className="w-full" size="lg" onClick={onConfirm}>
              Confirm
            </Button>
            <Button variant="secondary" className="w-full" size="lg" onClick={onClose}>
              Cancel
            </Button>
          </div>
        ) : (
          <div className="w-full">
            <Button variant="primary" className="w-full" size="lg" onClick={onClose}>
              Got it
            </Button>
          </div>
        )}
      </div>
    </Modal>
  );
}
